import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_oss_dialog, _mergeProps({
    modelValue: _ctx.openDialog,
    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.openDialog) = $event)),
    onValid: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onClickValidBtbDialog())),
    onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.resetDialog())),
    onPrevious: _cache[18] || (_cache[18] = ($event: any) => (_ctx.previousStep()))
  }, _ctx.dialogBind, { width: "800px" }), {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_tooltip, { location: "bottom" }, {
        activator: _withCtx(({ props: propsTT }) => [
          _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$oss-company" }, { ...propsTT, ...props }), null, 16)
        ]),
        default: _withCtx(() => [
          _cache[19] || (_cache[19] = _createElementVNode("span", null, "Immeubles", -1))
        ]),
        _: 2
      }, 1024)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_container, { class: "px-6 pb-6" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window, {
            modelValue: _ctx.step,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.step) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, { value: 0 }, {
                default: _withCtx(() => [
                  (!_ctx.buildings.properties.length)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 0,
                        "no-gutters": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "d-flex align-center justify-center py-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                class: "mr-5",
                                color: "secondary",
                                size: "large"
                              }, {
                                default: _withCtx(() => _cache[20] || (_cache[20] = [
                                  _createTextVNode("$oss-company")
                                ])),
                                _: 1
                              }),
                              _cache[21] || (_cache[21] = _createElementVNode("span", null, "Aucun immeuble", -1))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "d-flex justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "pb-2 title pl-3 text-center"
                            }, {
                              default: _withCtx(() => _cache[22] || (_cache[22] = [
                                _createTextVNode(" Immeubles ")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buildings.properties, (building, i) => {
                          return (_openBlock(), _createBlock(_component_v_list_item, {
                            key: i,
                            class: "mb-2"
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "d-flex flex-grow-0 flex-shrink-1" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn_icon, {
                                        icon: "$oss-edit",
                                        onClick: ($event: any) => (_ctx.buildingEdition(i))
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, { class: "d-flex flex-grow-0 flex-shrink-1" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn_icon, {
                                        icon: "$oss-trash",
                                        onClick: ($event: any) => (_ctx.removeBuilding(i))
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(building.name), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ], 64))
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "pt-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            label: "Nom de l'immeuble",
                            outlined: "",
                            modelValue: _ctx.property.name,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.property.name) = $event)),
                            "hide-details": "",
                            rules: [(v) => this.isExistingBuilding(v)],
                            density: "compact"
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "py-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => _cache[23] || (_cache[23] = [
                          _createElementVNode("h4", null, "Identification", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "6",
                        class: "pt-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.property.streetNumber,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.property.streetNumber) = $event)),
                            label: "Numéro de rue",
                            outlined: "",
                            "hide-details": "",
                            density: "compact"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "6",
                        class: "pl-2 pt-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select_filled, {
                            modelValue: _ctx.property.BTQ,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.property.BTQ) = $event)),
                            items: _ctx.BTQItems,
                            label: "Numéro de rue",
                            outlined: "",
                            "hide-details": "",
                            density: "compact"
                          }, null, 8, ["modelValue", "items"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "pt-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.property.address,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.property.address) = $event)),
                            label: "Adresse",
                            outlined: "",
                            "hide-details": "",
                            density: "compact"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "pt-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.property.addressComplement,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.property.addressComplement) = $event)),
                            label: "Complément d'adresse",
                            outlined: "",
                            "hide-details": "",
                            density: "compact"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "6",
                        class: "pt-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.property.city,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.property.city) = $event)),
                            label: "Ville",
                            outlined: "",
                            "hide-details": "",
                            density: "compact"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "6",
                        class: "pt-2 pl-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.property.country,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.property.country) = $event)),
                            label: "Pays",
                            outlined: "",
                            "hide-details": "",
                            density: "compact"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "4",
                        class: "pt-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.property.postalCode,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.property.postalCode) = $event)),
                            label: "Code Postal",
                            outlined: "",
                            "hide-details": "",
                            density: "compact"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "4",
                        class: "pt-2 pl-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_text_field_filled, {
                            modelValue: _ctx.property.numberOfRooms,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.property.numberOfRooms) = $event)),
                            label: "Nombre de locaux",
                            density: "compact",
                            "hide-details": ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "4",
                        class: "pt-2 pl-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_date_picker_filled, {
                            label: "Date d'acquisition",
                            modelValue: _ctx.property.acquiredDate,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.property.acquiredDate) = $event)),
                            textFieldReadOnly: false,
                            "text-field-readonly": false,
                            "hide-details": "auto"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "pt-1 pb-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "pb-2"
                      }, {
                        default: _withCtx(() => _cache[24] || (_cache[24] = [
                          _createElementVNode("h4", null, "Nature", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "6",
                        class: "pr-1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select_filled, {
                            class: "pr-1",
                            "hide-details": "",
                            modelValue: _ctx.property.natureA,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.property.natureA) = $event)),
                            items: _ctx.natureA,
                            "item-props": true,
                            "item-title": "description",
                            "item-value": "description",
                            label: "Immeuble A",
                            density: "compact"
                          }, {
                            item: _withCtx(({ props }) => [
                              _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_avatar, {
                                    color: "secondary",
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(props.icon), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1040)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "items"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "6",
                        class: "pl-1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select_filled, {
                            class: "pl-1",
                            "hide-details": "",
                            outlined: "",
                            modelValue: _ctx.property.natureB,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.property.natureB) = $event)),
                            items: _ctx.natureB,
                            "item-props": true,
                            "item-title": "description",
                            "item-value": "description",
                            label: "Immeuble B",
                            density: "compact"
                          }, {
                            item: _withCtx(({ props }) => [
                              _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_avatar, {
                                    color: "secondary",
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(props.icon), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1040)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "items"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "pt-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "pb-2"
                      }, {
                        default: _withCtx(() => _cache[25] || (_cache[25] = [
                          _createElementVNode("h4", null, "Déduction", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "6",
                        class: "pr-1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.property.specificDeduction,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.property.specificDeduction) = $event)),
                            label: "Déduction spécifique",
                            outlined: "",
                            "hide-details": "",
                            density: "compact"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "6",
                        class: "pl-1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.property.depreciationDeduction,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.property.depreciationDeduction) = $event)),
                            label: "Déduction amortissement",
                            outlined: "",
                            "hide-details": "",
                            density: "compact"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16, ["modelValue"]))
}